<template>
  <div ref="packetSelector" class="packetSelector">
    <div
      ref="packetSelectorInput"
      :class="['packetSelectorInput', { focus: inputFocused }]"
      @click="focusInput"
    >
      <div class="selectedContent">
          <Tag
            v-for="item in filteriInputData"
            :key="item.id"
            closable
            @on-close="deleteSelectedItem(item)"
            >
              <Tooltip placement="top" :content="item.title" :disabled="item.title.length>8" :delay="1000">
                <span>{{ item.title | max8}}</span>
              </Tooltip>
            </Tag>
            <Tag v-if = "inputData.length>30">
              ...
            </Tag>
      </div>
      <div class="ext">
        <Icon class="stateIcon" type="ios-arrow-down" />
      </div>
    </div>
    <div v-if="inputFocused" class="packetSelectorPopup">
      <div class="searchbox" :class="{focus : isFocus==true||search == true}">
        <input type="text" v-model="searchContent" placeholder="搜索" @focus="myFocus" @blur="myBlur" @input="myInput">
        <span v-show="isFocus==true||search == true" class="cancel" @click="searchBlur">取消</span>
      </div>
      <Tabs value="department">
        <TabPane
          v-for="(item, groupIndex) in options"
          :key="item.id"
          :label="item.label"
          :name="item.id"
          class="popupContent"
        >
          <Mytree :expand = 'expand' ref="treess" v-if="item.type === 'tree' && item.list.length && inputFocused" :list="item.list[0]" :dataKey="'orgId'" @select="_it=>treeCheckChange(_it, groupIndex)"></Mytree>
          <scrollLoad :pageSize = '20' :list = 'item.list' v-else-if="item.type === 'checkbox'">
            <template v-slot:default="slotProps">
              <Checkbox v-if = "selectAll" v-model = "checkAllState[groupIndex]" @on-change = "allCheck(groupIndex)">全选</Checkbox>
              <CheckboxGroup
                v-model="checkedData[groupIndex]"
                @on-change="checkboxChange"
              >
                <Checkbox
                  class="checkbox"
                  v-for="_item in slotProps.list"
                  :key="_item.id"
                  :label="JSON.stringify(_item)"
                  >{{ _item.title }}</Checkbox
                >
              </CheckboxGroup>
            </template>
          </scrollLoad>
        </TabPane>
      </Tabs>
      <div v-if="search == true" class="searchTree">
        <searchTree ref="child" :ipt="ipt" :_optionsData="options" :selectData="inputData" @parentListChange = 'parentListChange' @_fatherMethodTree="fatherMethodTree" @fatherMethod12="treeCheckChange" @depListChange = "_depListChange"></searchTree>
      </div>
    </div>
  </div>
</template>
<script>
import envConst from '@/env-const'
import searchTree from './searchTree.vue'
import Mytree from './tree/tree.vue'
import scrollLoad from './scrollLoad.vue'
// import treeList from './data.js'
export default {
  name: 'PacketSelector',
  components: {
    'searchTree': searchTree,   //注册子组件
    Mytree,
    scrollLoad
  },
  model: {
    prop: 'data',
    event: 'on-change'
  },
  props: {
    data: Array,
    options: Array,
    expand: Boolean,
    selectAll: Boolean
  },
  data() {
    return {
      inputFocused: false,
      checkedData: [[], [], []], // 已选中的数据
      inputData: [],
      isFocus: false,
      search: false,
      ipt: '',
      searchContent: '',
      checkAllState: [
        false,
        false,
        false
      ]
      // treeList
    }
  },
  computed:{
    filteriInputData(){
      if(this.inputData&&this.inputData.length <=30){
        return this.inputData
      }else{
        return this.inputData.slice(0,30)
      }
    }
  },
  watch: {
    data(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateTreeAndCheckboxActived(newValue)
      }
    },
    options: {
      handler(newValue) {
        if (newValue) {
          this.updateTreeAndCheckboxActived(this.data)
        }
      },
      immediate: true
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.packetSelector) {
        window.addEventListener('click', this.blurInput)
      }
    })
  },
  beforeDestroy() {
    if (this.$refs.packetSelector) {
      window.removeEventListener('click', this.blurInput)
    }
  },
  filters: {
    max8(str){
      if(str&&str.length<=5){
        return str
      }else if(str&&str.length>5){
        return str.substr(0,5)+'...'
      }
      return str
    }
  },
  methods: {
    //全选
    allCheck(index){
      if(this.checkAllState[index]){
        let nowList = this.options[index].list
        let selectArr = [...nowList]
        this.checkedData[index] = selectArr
      }else{
        this.checkedData[index] = []
      }
      this.checkboxChange()
    },
    //全选自动判断
    allCheckStatus(){
      for(let i = 1;i<3;i++){
        if(this.options.length&&this.options[i]){
          let list = this.options[i].list
          if(this.checkedData[i].length == list.length){
            this.checkAllState[i] = true
          }else{
            this.checkAllState[i] = false
          }
        }
      }
    },
    renderContent(h, { root, node, data }){
      return h('span', {
        attrs:{
          id: "self_"+data.id
        }
      },data.title)
    },
    myInput(e){
      console.log(e) 
      this.ipt = e.target.value;
      this.search = true;
      this.$nextTick(() => {
        this.$refs.child.request();
      })
    },
    myFocus(){
      // console.log('聚焦')
      this.isFocus = true
    },
    myBlur(){
      // console.log('失焦')
      this.isFocus = false;
      // this.search = false;  记得放开
    },
    // 取消按钮
    searchBlur(){
      this.search = false;
      this.searchContent = '';
    },
    // 聚焦输入框
    focusInput() {
      this.inputFocused = true
      this.updateTreeAndCheckboxActived(this.data)
    },
    // 失焦输入框
    blurInput(e) {
      if (!this.$refs.packetSelector.contains(e.target)) {
        this.inputFocused = false
        this.searchBlur()
      }
    },
    //list选中状态同步
    _depListChange(list){
      let _myList = this.options[0].list
      let checkData = this.checkedData[0].map(item => {
        if(typeof item === 'string'){
          return JSON.parse(item).id
        }
        return item.id
      })
      let filterIds = list.map(item => {
        return item.id
      })
      let checkDataList = []
      let checkList = _myList.forEach(item => {
        let bool = (checkData.indexOf(item.id) > -1)
        for(let i in list){
          if(list[i].id == item.id){
            if(list[i].checked){
              bool = true
            }else{
              bool = false
            }
          }
        }
        if(bool){
          checkDataList.push(JSON.stringify(item))
        }
      })
      this.$set(this.checkedData, 0, checkDataList)
      this.updateInputData()
      this.emitOnChange()
    },
    // 树的选中状态更新时同步到checkedData
    treeCheckChange(checked, groupIndex) {
      groupIndex = groupIndex || 0
      const checkedEndNode = checked.filter(item => {
        return true
      })
      this.$set(this.checkedData, groupIndex, checkedEndNode)
      this.updateInputData()
      this.emitOnChange()
    },
    parentListChange({selected,index,list}) {
      let _myList = this.options[index].list
      let checkData = this.checkedData[index].map(item => {
        if(typeof item === 'string'){
          return JSON.parse(item).id
        }
        return item.id
      })
      let filterIds = selected.map(item => {
        return item.id
      })
      for(let i in list){
        list[i].checked = (filterIds.indexOf(list[i].id)>-1)
      }
      let checkDataList = []
      let checkList = _myList.forEach(item => {
        let bool = (checkData.indexOf(item.id) > -1)
        for(let i in list){
          if(list[i].id == item.id){
            if(list[i].checked){
              bool = true
            }else{
              bool = false
            }
          }
        }
        if(bool){
          checkDataList.push(JSON.stringify(item))
        }
      })
      this.$set(this.checkedData, index, checkDataList)
      this.updateInputData()
      this.emitOnChange()
    },
    fatherMethodTree({checked,index}){
      // 暂时无用
      console.log('checked==',checked)
    },
    // 复选框组改变
    checkboxChange(selected) {
      console.log(selected)
      this.allCheckStatus()//全选自动判断
      this.updateInputData()
      this.emitOnChange()
    },
    out_dg(item,cb){
      cb && cb(item);
      if(item.children && item.children.length){
        for(let i in item.children){
          this.out_dg(item.children[i],cb)
        }
      }
    },
    checkboxChange1({selected}) {
      this.inputData = this.inputData.filter(_item => _item.id !== selected.id)
      let type = this.options[0].type
      let list = type === 'tree'?this.options[0].list[0]:this.options[0].list
      if(type === 'tree'){
        this.out_dg(list,item => {
            let index = this.checkedData[0].indexOf(item)
            if(selected.checked&&(item.id == selected.id)){
              item.checked = true
              console.log(item.checked)
              if(index==-1){
                // this.checkedData[0].push(item)
              }
            }else if(!selected.checked&&(item.id == selected.id)){
              item.checked = false
              if(index>-1){
                // this.checkedData[0].splice(index,1)
              }
            }
        })
      }else{
        list.forEach(item => {
          if(selected.checked&&(item.id == selected.id)){
            this.checkedData[0].push(item)
          }else if(!selected.checked&&(item.id == selected.id)){
            let index = this.checkedData[0].indexOf(item)
            if(index>-1){
              this.checkedData[0].splice(index,1)
            }
          }
        })
      }
      this.updateInputData()
      this.emitOnChange()
    },
    // 删除选中的项目
    deleteSelectedItem(delitem) {
      console.log('删除选中项目', delitem)
      if(delitem.children){
        this.inputFocused = true
        this.options.forEach((item, index) => {
          if (item.type === 'tree') {
            const ergodicList = list => {
              list.forEach((_item, index) => {
                if(delitem.id==_item.id){
                  console.log(_item)
                  if(this.$refs.treess && this.$refs.treess.length){
                    this.$refs.treess[0]._delsuccess(delitem,false);
                  }
                }
                if (_item.children && _item.children.length > 0) {
                  ergodicList(_item.children)
                }
              })
            }
            ergodicList(item.list)
          }
        })
        this.inputData = this.inputData.filter(_item => _item.id !== delitem.id)
      }else{
        this.inputData = this.inputData.filter(_item => _item.id !== delitem.id)
        this.updateTreeAndCheckboxActived(this.inputData.map(_item => _item.id))
      }
      this.selectData = [...this.inputData]
      this.emitOnChange()
    },
    // 更新输入框中的数据
    updateInputData() {
      const flatten = array => {
        let flattend = []
        ;(function flat(array) {
          array.forEach(function(el) {
            if (Array.isArray(el)) flat(el)
            else flattend.push(el)
          })
        })(array)
        return flattend
      }
      const checkedDataFlat = flatten(this.checkedData)
      this.inputData = checkedDataFlat.map(item => {
        return typeof item === 'string' ? JSON.parse(item) : item
      })
      this.selectData = [...this.inputData]
    },
    // 工具，通过id在各组数据中找出对象
    findItemById(id) {
      const ergodicList = function(id, list) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].id === id) {
            return list[i]
          } else if (list[i].children && list[i].children.length > 0) {
            let item = ergodicList(id, list[i].children)
            if (item) {
              return item
            } else {
              continue
            }
          }
        }
      }
      for (let i = 0; i < this.options.length; i++) {
        let item = ergodicList(id, this.options[i].list)
        if (item) {
          return {
            group: this.options[i],
            groupIndex: i,
            item
          }
        }
      }
    },
    // 全部清空选中状态
    clearSelected() {
      this.checkedData.forEach((item, index) => {
        this.$set(this.checkedData, index, [])
      })
      this.options.forEach((item, index) => {
        if (item.type === 'tree') {
          const ergodicList = list => {
            list.forEach((_item, index) => {
              this.$set(_item, 'checked', false)
              this.$set(_item, 'indeterminate', false)
              // this.$set(_item, 'expand', item.expand)
              if (_item.children && _item.children.length > 0) {
                ergodicList(_item.children)
              }
            })
          }
          ergodicList(item.list)
        }
      })
    },
    // 通过data数据回显选择器
    updateTreeAndCheckboxActived(data) {
      if (data) {
        this.clearSelected()
        data.forEach(id => {
          let itemAndGroup = this.findItemById(id)
          if (itemAndGroup) {
            if (itemAndGroup.group.type === 'checkbox') {
              this.checkedData[itemAndGroup.groupIndex].push(
                JSON.stringify(itemAndGroup.item)
              )
              return
            } else if (itemAndGroup.group.type === 'tree') {
              this.$set(itemAndGroup.item, 'checked', true)
              this.checkedData[itemAndGroup.groupIndex].push(itemAndGroup.item)
              return
            }
          }
        })
        this.allCheckStatus()//全选自动判断
        this.updateInputData()
      }
    },
    emitOnChange() {
      // 触发iview的formItem校验
      this.$parent.$emit(`on-form-change`)
      this.$emit('on-change', this.inputData.map(item => item.id))
    }
  }
}
</script>
<style lang="stylus">
.packetSelector .ivu-tag
  border 1px #00CBD9 solid
  background #E4F9FB
.packetSelector .ivu-tag>span
  color #00CBD9
.packetSelector .ivu-tag>i
  color #00CBD9

.searchbox
  position absolute
  right 0
  width 70px
  height 36px
  z-index 9
  display flex
  justify-content space-around
  input 
    width 100%
    border-radius 20px
    border none 
    outline none
    background-color #F1F7F7
    text-indent 3em
    background-image url('../../assets/images/search.png')
    background-repeat no-repeat
    background-size 18px
    background-position 10px center

.searchbox.focus
  width 100%
  left 0
  right auto
  input 
    width 90%

.cancel
  color #36C6D0
  cursor pointer
  line-height: 36px;
.searchTree
  position absolute
  width 100%
  height calc(100% - 38px)
  top 38px
  padding-left 20px
  z-index 999
  background #fff


.packetSelector
  position relative

  .packetSelectorInput
    display flex
    width 100%
    min-height 37px
    max-height 90px
    line-height 1.5
    padding 4px 7px
    font-size 12px
    border 1px solid #dcdee2
    border-radius 4px
    color #515a6e
    background-color #fff
    background-image none
    position relative
    transition all 0.2s ease-in-out
    cursor text

    &:hover
      border-color #04cbd8

    &.focus
      border-color #04cbd8
      outline 0
      box-shadow 0 0 0 2px rgba(45, 140, 240, 0.2)

      .stateIcon
        transition transform 0.2s ease-in-out
        transform rotate(180deg)

    .stateIcon
      transition transform 0.2s ease-in-out

    .selectedContent
      width 90%
      overflow auto

    .ext
      width 10%
      display flex
      justify-content center
      align-items center

  .packetSelectorPopup
    position absolute
    top auto
    left 0
    width 100%
    background #fff
    overflow auto
    border-radius 4px
    box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
    z-index 2
    min-height 150px

    .popupContent
      padding 0 15px 20px 15px
      // max-height 400px
      height 300px
      overflow auto

      .checkbox
        display block
        margin 5px 0
        word-break break-all
</style>
<style scoped>
/deep/ .ivu-tabs-bar{
  width: calc(100% - 70px);
}
</style>